export class ApiConfig {
  public host: string = '/api';
}
